import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { filterChange } from '../../actions/index';

import Select from '@material-ui/core/Select';
import ListSubheader from '@material-ui/core/ListSubheader';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';

import { _ } from '../../functions/translator.js';
import { hasElementsMatch } from '../../functions/finder';
import { getAvailableCardCategoryIds } from '../../functions/getter.js';
import { FilterActions } from '../../constants/constants.js';

class CategoryDropdown extends React.Component{

    handleCategoryChange = (event) => {
        let categoryIdsSelected = [];
        let stageSelected = null;
        for (const categoryIdSelected of event.target.value) {
            const isAStage = typeof categoryIdSelected === 'object';
            if (isAStage) {
                stageSelected = categoryIdSelected;
            } else {
                categoryIdsSelected.push(categoryIdSelected);
            }
        }
        if (stageSelected) {
            categoryIdsSelected = this.handleStageSelected(categoryIdsSelected, stageSelected);
        }
        this.props.filterChange(FilterActions.CARD_CATEGORIES, categoryIdsSelected);
    };

    handleSelected = (categoriesSelected) => {
        if (categoriesSelected.length === 0) {
            return _('Categorías');
        } else {
            let categoryNames = []
            for (const categoryId of categoriesSelected) {
                let categoryData = this.props.cardCategories[categoryId.toString()]
                categoryNames.push(categoryData.attributes.name)
            }
            return categoryNames.join(', ')
        }
    }

    handleStageSelected = (categoryIdsSelected, stageSelected) => {
        let stageCategoriesData = Object.values(this.props.cardCategories).filter((categoryData) => { 
            return categoryData.attributes.stage_id === stageSelected.id
                   && hasElementsMatch(this.props.levelIds, this.props.matches.levels_card_categories, categoryData.id);
        });
        let stageCategoryIds = stageCategoriesData.map((categoryData) => {
            return categoryData.id;
        })
        let stageCategoriesSelected = stageCategoryIds.map((categoryId) => { 
            return categoryIdsSelected.indexOf(categoryId) !== -1;
        });
        const stageHasAllCategoriesSelected = !stageCategoriesSelected.includes(false);
        if (stageHasAllCategoriesSelected) {
            categoryIdsSelected = categoryIdsSelected.filter((categoryId) => {
                return !stageCategoryIds.includes(categoryId);
            });
        } else {
            stageCategoryIds.forEach((categoryId) => {
                if (!categoryIdsSelected.includes(categoryId)) {
                    categoryIdsSelected.push(categoryId);
                }
            });
        }
        return categoryIdsSelected;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.levelIds !== this.props.levelIds) {
            let categoryIds = []
            for (const categoryId of this.props.cardCategoryIds) {
                if (hasElementsMatch(this.props.levelIds, this.props.matches.levels_card_categories, categoryId)) {
                    categoryIds.push(categoryId)
                }
            }
            if (categoryIds.length !== this.props.cardCategoryIds.length) {
                this.props.filterChange(FilterActions.CARD_CATEGORIES, categoryIds)
            }
        }
    }

    render() {
        const options = []
        for (const stageData of Object.values(this.props.stagesData)) {
            if (this.props.stageIds.length > 0 && !this.props.stageIds.includes(stageData.id)) continue;
            options.push(
                <ListSubheader color="inherit" value={stageData} classes={{root: 'cursor-pointer'}}>
                    {stageData.attributes.name}
                </ListSubheader>
            );
            const availableCardCategoryIds = getAvailableCardCategoryIds(
                this.props.cardCategories,
                [stageData.id],
                this.props.levelIds,
                this.props.matches.levels_card_categories
            )
            for (const [key, categoryData] of Object.entries(this.props.cardCategories)) {
                if (availableCardCategoryIds.includes(categoryData.id)) {
                    options.push(
                        <MenuItem value={categoryData.id} key={key}>
                            <Checkbox color="primary" checked={this.props.cardCategoryIds.includes(categoryData.id)}/>
                            {categoryData.attributes.name}
                            <div 
                            className='color-square right-layout' 
                            style={{ backgroundColor: categoryData.attributes.color }}>
                            </div>
                        </MenuItem>
                    )
                }
            }
        }

        return(
            <div>
                <Select
                value={this.props.cardCategoryIds}
                multiple={true}
                displayEmpty={true}
                renderValue={this.handleSelected}
                onChange={this.handleCategoryChange}
                MenuProps={{
                    PaperProps: {
                        style: {
                          maxHeight: 300,
                          top: '0px',
                          position: 'fixed',
                        },
                    },
                    getContentAnchorEl: null,
                }}>
                {options}
                </Select>
            </div>
        );
    }
}

function mapStateToProps( state ){
    return {
        stageIds        : state.filters.stageIds,
        levelIds        : state.filters.levelIds,
        cardCategoryIds : state.filters.cardCategoryIds,
        cardCategories  : state.projectData.card_categories,
        stagesData      : state.projectData.stages,
        matches         : state.matches
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        filterChange     : filterChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(CategoryDropdown);